export const currencyBaseQueryKey = 'currencyData';
export const generateKeys = {
    currencyBaseQueryKey: () => [currencyBaseQueryKey],
};
